import { WalletViewModel } from '@apis/model/wallet/WalletViewModel';
import { ScaInitViewModel } from '@apis/model/wallet/ScaInitViewModel';
import { PasskeyInfo, ResponseCode, WalletAuthRequest, WalletResetPinRequest, WalletScaRequest } from '@ul/api';
import { MFAOperationCode, TransactionDataResponse } from '@ul/common';
import React from 'react';
import { StoreApi } from 'zustand';

export type WalletAuthState = 'otp' | 'pin' | 'dob' | 'result' | 'loading';
export type WalletResultState = 'success' | 'warn' | 'error';
export type WalletFlow = 'resetPin' | 'auth' | 'sca';
export type WalletResultMessage = {
    title: string;
    caption: string;
};

export type WalletAuthFormState = {
    walletAuthState: WalletAuthState;
    dob?: string;
    otpVm?: WalletViewModel['otpViewModel'];
    pin?: string;
    resultState?: WalletResultState;
    walletResultMessage?: WalletResultMessage;
    transactionInfo?: Partial<TransactionDataResponse>;
    isBlocked?: boolean;
    currentFlow?: WalletFlow;
    passkey?: PasskeyInfo;
};

export type WalletAuthFormStateFunction = {
    setWalletAuthState: (state: WalletAuthState) => void;
    setPin: (pin: string) => void;
    setOtpVm: (otpVm: WalletViewModel['otpViewModel']) => void;
    setDob: (dob: string) => void;
    setWalletResultState: (state: WalletResultState) => void;
    setWalletResultMessage: (result: WalletResultMessage) => void;
    setTransactionData: (transaction: TransactionDataResponse) => void;
    setIsBlocked: (isBlocked: boolean) => void;
    setPasskey: (passkey: PasskeyInfo) => void;
};

export type WalletContextProps = {
    walletStorage: StoreApi<WalletAuthFormState & WalletAuthFormStateFunction>;
    onSubmit: (
        request: Partial<WalletAuthRequest | WalletScaRequest | WalletResetPinRequest>,
        onPasskeyCallback?: () => Promise<void>,
        isCancelled?: () => boolean
    ) => Promise<void>;
    onPinSubmit: (pin: string) => Promise<void | boolean>;
    onResendOtp: () => Promise<void>;
    onPasskeyAuth?: (responseCode: ResponseCode) => void;
    onInit?: () => Promise<ScaInitViewModel>;
};

const WalletContext = React.createContext<WalletContextProps | null>(null);
WalletContext.displayName = 'WalletContext';
export { WalletContext };
